import * as effects from 'redux-saga/effects';

export function* handleError(error) {
  yield effects.call(console.error(error));
}
